var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"imd-sm-input-chkbox",attrs:{"label":_vm.label,"value":_vm.value},on:{"change":function (value) { return _vm.$emit('input', value); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }